<template>
  <div>
    <!-- header -->
    <Header></Header>

    <!-- Banner -->
    <SubBanner></SubBanner>

    <article class="ceo-wrapper">
      <div class="container">
        <!-- 상세 페이지 -->
        <div class="ceo-detail">
          <div class="select-wrapper">
            <ul class="month">
              <li @click="goPrev">
                <img src="@/assets/img/newGlobal/introduce/sub/ceo/arrow-prev.png" alt="prev" class="btn" />
              </li>
              <li>{{ magazine_name }}</li>
              <li @click="goNext">
                <img src="@/assets/img/newGlobal/introduce/sub/ceo/arrow-next.png" alt="next" class="btn" />
              </li>
            </ul>
            <ul class="pdf-mail">
              <li @click="goBack">
                <img src="@/assets/img/newGlobal/introduce/sub/ceo/list.png" alt="see" />
                <p>list 보기</p>
              </li>
              <li @click="SeeDetail(file3_url)">
                <img src="@/assets/img/newGlobal/introduce/sub/ceo/see.png" alt="see" />
                <p>크게보기</p>
              </li>
            </ul>
          </div>
          <img :src="file2_url" alt="img" class="message" />
        </div>
      </div>
    </article>

    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/NewGlobal/Introduce/Header.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import SubBanner from "@/components/NewGlobal/Introduce/SubBanner.vue";
import "@/assets/style/newGlobalReset.scss";

export default {
  name: "Ceo",
  components: {
    Header,
    SubBanner,
    Footer,
  },
  data() {
    return {
      magazine_name: "",
      file2_url: "",
      file3_url: "",
      prev_idx: "",
      next_idx: "",
    };
  },
  mounted() {
    // const header = document.getElementById("header");
    // header.style.display = "none";

    this.getCeomessage();
  },
  methods: {
    // 메세지 상세 데이터 불러오기
    getCeomessage() {
      const params = {
        idx: this.$route.query.idx,
      };

      axios
        .get("/rest/external/getCeomessage", { params })
        .then((res) => {
          if (res.data.err == 0) {
            this.magazine_name = res.data.magazine_name;
            this.file2_url = res.data.file2_url;
            this.file3_url = res.data.file3_url;
            this.prev_idx = res.data.prev_idx;
            this.next_idx = res.data.next_idx;
          } else {
            console.error("res.data.err : ", res.data.err);
          }
        })
        .catch((err) => {
          alert("통신이 원활하지 않습니다.");
          console.error("err : ", err);
        });
    },

    // 목록으로 가기
    goBack() {
      this.$router.push({
        path: "./CeoList",
      });
    },

    // 이전 글
    goPrev() {
      if (this.prev_idx !== 0) {
        this.$router.push({
          path: `/CeoDetail?idx=${this.prev_idx}`,
        });
      }

      if (this.prev_idx == 0) {
        alert("첫 게시물입니다.");
      }

      this.getCeomessage(this.prev_idx);
    },

    // 다음 글
    goNext() {
      if (this.next_idx !== 0) {
        this.$router.push({
          path: `/CeoDetail?idx=${this.next_idx}`,
        });
      }

      if (this.next_idx == 0) {
        alert("마지막 게시물입니다.");
      }

      this.getCeomessage(this.next_idx);
    },

    // 크게보기
    SeeDetail(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ceo-wrapper {
  .ceo-detail {
    padding: 40px 0;

    @media screen and (min-width: 1350px) {
      padding: 80px 0;
    }

    .select-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      margin-bottom: 20px;

      @media screen and (min-width: 1350px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      .month {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;

        .btn {
          cursor: pointer;
        }
      }

      .pdf-mail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 5px;
          font-size: 14px;
          color: #ff4200;
          cursor: pointer;
        }
      }
    }

    .message {
      width: 100%;
    }
  }
}
</style>
